import React from "react";
import PermitApprovers from "../PermitApprovers";
import { warehouseInOutPermitSupportingDocuments, WorkPermitApprover } from "../../../constants/common";
import PermitDetails from "./PermitDetails";
import SupportingDocuments from "../SupportingDocuments";
import AccompanyingPersonnelDetails from "./AccompanyingPersonnelDetails";
import DetailedDescriptionOfItems from "./DetailedDescriptionOfItems";
import VehicleInformation from "./VehicleInformation";
import PermitValidity from "./PermitValidity";
import Wrapper from "../Wrapper";

interface WarehouseInOutPermitPDFProps {
  permitDetails: {
    s_ExitBuilding: string;
    s_EntryBuilding: string;
    s_EscortingEmployeeName: string;
    s_PermitDescriptionCode_En: string;
    s_PermitDescriptionOthersValue: string;

    haveUserCard: boolean;

    permitPersonnel: {
      s_PersonnelName: string;
      nationality_En: string;
      s_Iqama: string;
      dt_IqamaIssue: any;
      s_IssuingAuthority: string;
      haveIqamaUpload: boolean;
    }[]

    permitItems: {
      s_ItemType: string;
      n_Quantity: number;
      s_SupplyingOrExportingEntity: string;
    }[]

    permitVehicles: {
      s_PlateSource_En: string;
      s_PlateLetter1_En: string;
      s_PlateLetter2_En: string;
      s_PlateLetter3_En: string;
      s_PlateNumber: string;
      s_Color: string;
    }[];

    dt_PermitStartDate: string;
    dt_PermitEndDate: string;

    approvers: WorkPermitApprover[];
  };
}

const WarehouseInOutPermitPDF: React.FC<WarehouseInOutPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="Warehouse In/Out Permit">
      <PermitDetails permitDetails={permitDetails} />
      <SupportingDocuments sectionNumber={2} permitDetails={permitDetails} documents={warehouseInOutPermitSupportingDocuments} />
      <AccompanyingPersonnelDetails permitPersonnel={permitDetails?.permitPersonnel} />
      <DetailedDescriptionOfItems permitItems={permitDetails?.permitItems} />
      <VehicleInformation vehicles={permitDetails?.permitVehicles} />
      <PermitValidity permitDetails={permitDetails} />
      <PermitApprovers sectionNumber={7} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default WarehouseInOutPermitPDF;
